import { group, extent } from 'd3';
import { useMemo } from 'react';
import LineChart from '..';
import { element, useElementProps } from '../../../core/elements';
import { scaleTime, scalePoint, scaleLinear, scaleLog, scaleOrdinal } from '../../../primitives/scale';
export const LineScales = element(props => {
  const {
    data,
    x,
    y,
    color,
    width,
    height,
    log,
    yDomain
  } = props;
  const {
    fillStyles,
    useThemeFillStyles
  } = useElementProps(LineChart.elements.Theme);
  // TODO: children should come from hook

  const value = useMemo(() => {
    var _extentYValues$;
    const xScale = x(data[0]) instanceof Date || x(data[data.length - 1]) instanceof Date ? scaleTime({
      // TODO: make sure this works with unique values
      // @ts-expect-error - extent might return [undefined, undefined]
      domain: extent(data, x),
      range: [0, width]
    }) : scalePoint({
      // TODO: make sure this works with unique values
      domain: [...new Set(data.map(x))],
      range: [0, width],
      padding: 0
    });

    // d3 max can handle null values
    const extentYValues = extent([...data.map(y)]);
    const yDomainOutput = [log ? 1 : extentYValues[0], (_extentYValues$ = extentYValues[1]) !== null && _extentYValues$ !== void 0 ? _extentYValues$ : 1];
    if (yDomain && yDomain[0] !== null) {
      yDomainOutput[0] = yDomain[0];
    }
    if (yDomain && yDomain[1] !== null) {
      yDomainOutput[1] = yDomain[1];
    }
    const yScale = !props.log ? scaleLinear({
      domain: yDomainOutput,
      range: [height, 0]
    }) : scaleLog({
      domain: yDomainOutput,
      range: [height, 0]
    });
    const {
      domain,
      range
    } = useThemeFillStyles({
      fillStyles
    });
    const colorScale = scaleOrdinal({
      domain: domain ? domain : data.map(color),
      range: range
    });
    const seriesData = group(data, x);
    return {
      xScale,
      yScale,
      colorScale,
      seriesData
    };
  }, [data, x, y, color, width, height, log, yDomain]);
  return props.children(value);
});